import InventoryCard from "../../Cards/InventoryCard";
import MetaOptionsCard from "../../Cards/MetaOptionsCard";
import VariationsCard from "../../Cards/VariationsCard";
import ShippingCard from "../../Cards/ShippingCard";

const AdvancedTab = () => {

    return (
        <div className="tab-pane fade show active" id="kt_ecommerce_add_product_advanced" role="tab-panel">
            <div className="d-flex flex-column gap-7 gap-lg-10">
                <InventoryCard/>
                <MetaOptionsCard/>
                {/*<VariationsCard/>*/}
                {/*<ShippingCard/>*/}
            </div>
        </div>
    )
}

export default AdvancedTab;